<template>
<section class="signature">
          <div class="signatureBox">
              <div class="canvasBox" ref="canvasHW">
                  <canvas ref="canvasF" @touchstart='touchStart' @touchmove='touchMove' @touchend='touchEnd' ></canvas>
                  <div class="btnBox flex-row" >
                      <div @click="overwrite">重签</div>
                      <div @click="commit">提交签名</div>
                  </div>   
              </div>
          </div>
      </section>
</template>
<script>
import { setTimeout } from 'timers';
import { signContract,signContractOfTile, signServiceBillPDF } from '@/api/index';
import { put } from '@/utils/auth.js';
import { Notify } from 'vant';
  export default {
    props:["fromRoute"],
    data() {
      return {
        stageInfo:'',
        imgUrl:'',
        client: {},
        points: [],
        canvasTxt: null,
        startX: 0,
        startY: 0,
        moveY: 0,
        moveX: 0,
        endY: 0,
        endX: 0,
        w: null,
        h: null,
        isDown: false,
        isViewAutograph: this.$route.query.isViews > 0,
        contractSuccess: this.$route.query.contractSuccess,
        editStatus: false,
        isTile: false,
      }
    },
    mounted() {
        this.configure();
        let items = JSON.parse(this.$route.query.item);
        this.isTile = items.brandName == '蒙娜丽莎';
    },
    methods: {
      configure(){
            let canva = this.$refs.canvasF
            canva.height = this.$refs.canvasHW.offsetHeight - 300
            canva.width = this.$refs.canvasHW.offsetWidth
            this.canvasTxt = canva.getContext('2d');
            this.canvasTxt.strokeStyle="#000000"; 
            this.stageInfo = canva.getBoundingClientRect()
            this.canvasTxt.lineWidth = 3;
      },
      //mobile
      touchStart(ev) {
        this.editStatus = true;
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clienX,
            y: ev.targetTouches[0].clientY,
          }
          this.startX = obj.x
          this.startY = obj.y
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
        }
      },
      touchMove(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - this.stageInfo.left,
            y: ev.targetTouches[0].clientY - this.stageInfo.top
          }
          this.moveY = obj.y
          this.moveX = obj.x
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.startY = obj.y
          this.startX = obj.x
          this.points.push(obj)
        }
      },
      touchEnd(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - this.stageInfo.left,
            y: ev.targetTouches[0].clientY - this.stageInfo.top
          }
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
        }
      },
      dataURLtoFile(dataurl, filename) {//将base64转换为文件
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
      },
      //重写
      overwrite() {
        this.editStatus = false;
        this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height)
        this.points = []
      },
      //提交签名
      commit() {
        if(!this.editStatus){
          Notify({ type: 'danger', message: '签名不能为空！' });
          return false;
        }
        this.imgUrl=this.$refs.canvasF.toDataURL();
        let data ={
            content: this.imgUrl,
            file:this.dataURLtoFile(this.imgUrl,"sing.png")
        }
        put(data).then(res=>{
            this.urls = res.url;
            //服务单签字
            if(this.fromRoute == '/servicedetail'){
              this.serviceFun(res.name);
            }else{
              //合同签字
              this.setData(res.name);
            }
            
        }).catch(error=>{

        })
      },
      serviceFun(imgUrl){
        const params = {
          serviceBillId: this.$route.query.serviceBillId,
          imgUrl
        }
        signServiceBillPDF(params).then(res=>{
          if (res.status == 200) {
              this.$parent.getMsgFormSon(1);
          } else {
              Notify({ type: 'danger', message: res.message });
          }
        }).catch(error=>{
        })
      },
      setData(el){
        let phone = this.$loca.getItem('phone') || this.$route.query.phone;
        let name = this.$loca.getItem('name') || this.$route.query.name;
        const queryItem = JSON.parse(this.$route.query.item);
        const params = {
            autographFileName: el,
            contractFileName: queryItem.contractFileName,
            customerContractId: queryItem.customerContractId,
            orderId: queryItem.orderId,
            type: queryItem.type,
            phone: phone,
            name: name
        }
        let func = this.isTile ? signContractOfTile : signContract;
        func(params).then(res=>{
          if (res.status == 200) {
              this.$parent.getMsgFormSon(0);
          } else {
              Notify({ type: 'danger', message: res.message });
          }
        }).catch(error=>{
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .signatureBox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    z-index: 100;
    display: flex;
    flex-direction: column;
  }
  .canvasBox {
    box-sizing: border-box;
    flex: 1;
  }
.btnBox {
// padding: 10px;
text-align: center;
justify-content: space-around;
}
.btnBox div:first-of-type {
background: #F56C6C;
border-radius: 4px;
height: 82px;
width: 50%;
line-height: 82px;
font-size: 32px;
color: #ffffff;
}
.btnBox div:last-of-type {
background: #67C23A;
color: #fff;
border-radius: 4px;
height: 82px;
width: 50%;
line-height: 82px;
font-size: 32px;
}
  
</style>
